/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeverityRatesResponseDto
 */
export interface SeverityRatesResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SeverityRatesResponseDto
     */
    percentage: string;
    /**
     * 
     * @type {string}
     * @memberof SeverityRatesResponseDto
     */
    lowSeverity: string;
    /**
     * 
     * @type {string}
     * @memberof SeverityRatesResponseDto
     */
    averageSeverity: string;
    /**
     * 
     * @type {string}
     * @memberof SeverityRatesResponseDto
     */
    highSeverity: string;
    /**
     * 
     * @type {string}
     * @memberof SeverityRatesResponseDto
     */
    puEq: string;
    /**
     * 
     * @type {Date}
     * @memberof SeverityRatesResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SeverityRatesResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the SeverityRatesResponseDto interface.
 */
export function instanceOfSeverityRatesResponseDto(value: object): value is SeverityRatesResponseDto {
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    if (!('lowSeverity' in value) || value['lowSeverity'] === undefined) return false;
    if (!('averageSeverity' in value) || value['averageSeverity'] === undefined) return false;
    if (!('highSeverity' in value) || value['highSeverity'] === undefined) return false;
    if (!('puEq' in value) || value['puEq'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SeverityRatesResponseDtoFromJSON(json: any): SeverityRatesResponseDto {
    return SeverityRatesResponseDtoFromJSONTyped(json, false);
}

export function SeverityRatesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeverityRatesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'percentage': json['percentage'],
        'lowSeverity': json['lowSeverity'],
        'averageSeverity': json['averageSeverity'],
        'highSeverity': json['highSeverity'],
        'puEq': json['puEq'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SeverityRatesResponseDtoToJSON(json: any): SeverityRatesResponseDto {
    return SeverityRatesResponseDtoToJSONTyped(json, false);
}

export function SeverityRatesResponseDtoToJSONTyped(value?: SeverityRatesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percentage': value['percentage'],
        'lowSeverity': value['lowSeverity'],
        'averageSeverity': value['averageSeverity'],
        'highSeverity': value['highSeverity'],
        'puEq': value['puEq'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

